import { useEffect } from 'react';

import { httpGetFields } from '@iconik-io/iconik-api/src/services/metadata';

import {
  useAppDispatch,
  useAppSelector,
} from '../../../../../redux/redux_hooks';
import { ACTION_TYPE, useApiReducer } from './use_api_reducer';

// TODO: RP-1699 Refactor/reconsider data-fetching for metadata
export function useMetadataFields() {
  const appDispatch = useAppDispatch();
  const [_, apiDispatch] = useApiReducer();
  const metadataFields = useAppSelector(
    (state) => state.entities.metadata_fields,
  );
  const hasLoadedFields = Object.keys(metadataFields).length > 0;

  useEffect(() => {
    if (hasLoadedFields) {
      return;
    }

    apiDispatch({
      type: ACTION_TYPE.START,
    });

    appDispatch(httpGetFields())
      .then(() => {
        apiDispatch({
          type: ACTION_TYPE.SUCCESS,

          // State is normalized in redux store, no need to keep it local state.
          payload: null,
        });
      })
      .catch(() => {
        apiDispatch({
          type: ACTION_TYPE.ERROR,
        });
      });
  }, [apiDispatch, hasLoadedFields]);

  return { isLoading: !hasLoadedFields, fields: metadataFields };
}
